import Text from '@creator/ui/components/Text/Text';
import type { ParagraphData } from '@editorjs/paragraph';
import { cleanHtml } from '@src/utils/html-utils/html-utils';
import { memo } from 'react';
import type { FC } from 'react';

export interface EditorViewOnlyParagraphToolProps {
    className?: string;
    blockData: ParagraphData;
}

const EditorViewOnlyParagraphTool: FC<EditorViewOnlyParagraphToolProps> = props => {
    const { blockData, className } = props;

    function renderContent() {
        const { text } = blockData;

        return (
            <div className="ce-paragraph cdx-block">
                <p dangerouslySetInnerHTML={{ __html: cleanHtml(text) }} />
            </div>
        );
    }

    return <div className={`paragraph-tool ${className}`}>{renderContent()}</div>;
};

export default memo(EditorViewOnlyParagraphTool);
